import { Filesystem } from "@capacitor/filesystem";
import { FilePicker } from "@capawesome/capacitor-file-picker";

export const uploadFileToIos = async (
  handleSetFiles: (files: File) => void
) => {
  await FilePicker.pickImages({
    multiple: false,
  }).then(async (e) => {
    const readFile: any = await Filesystem.readFile({
      path: String(e.files[0].path),
    });

    const byteCharacters = atob(readFile.data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: e.files[0].mimeType });

    const file = new File([blob], e.files[0].name, {
      type: e.files[0].mimeType,
    });
    // setFiles((old) => [...old, file]);
    handleSetFiles(file);
  });
};
